<template>
  <div class="question">
    <div class="question-description">
      <div class="question-number">{{ number }}</div>
      <div class="question-title">
        {{ title }}
      </div>
      <div class="question-answer" :class="answerClass">
        {{ answer }}
      </div>
    </div>
    <div class="question-form">
      <v-slider v-model="input" @input='changeInput' />
      <div class="applicable hidden-xs" @click.prevent="applicableClick">
        <div class="text">Não aplicável</div>
        <div class="checkbox"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'question',
  props: {
    number: Number,
    field: String,
    reverse: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Number,
      default: 0,
    },
    title: String,
  },
  data() {
    let value = this.value
    if (this.reverse) {
      value = 100 - value
    }
    return {
      input: value,
      answer: 'N/A',
      answerClass: 'grey-dark',
    };
  },
  mounted() {
    let value = this.value
    if (this.reverse) {
      value = 100 - value
    }
    if (this.value > 0) this.isApplicable(true)
  },
  methods: {
    changeInput(value) {
      if (this.reverse) {
        this.$emit('input', 100 - value, this.field)
      } else {
        this.$emit('input', value, this.field)
      }
      
      value > 0 ? this.isApplicable(true) : this.isApplicable(false)
      switch (true) {
        case value === 0:
          this.answer = 'N/A'
          this.answerClass = 'grey-dark'
          break
        case value <= 25:
          this.answer = 'Discordo totalmente'
          this.answerClass = 'grey'
          break
        case value <= 50:
          this.answer = 'Discordo em partes'
          this.answerClass = 'grey'
          break
        case value <= 75:
          this.answer = 'Concordo em partes'
          this.answerClass = 'green'
          break
        case value <= 100:
          this.answer = 'Concordo totalmente'
          this.answerClass = 'green'
          break
        default:
          this.answer = 'N/A'
          this.answerClass = 'grey-dark'
      }
    },
    applicableClick(event) {
      event.currentTarget.classList.contains('active') ?
        this.isApplicable(false) :
        this.isApplicable(true)
    },
    isApplicable(boolean) {
      const el = this.$el.querySelector('.applicable')
      const text = el.querySelector('.text')
      if (boolean) {
        el.classList.add('active')
        text.innerHTML = 'Aplicável'
        if (this.input === 0) this.input = 1
      } else {
        el.classList.remove('active')
        text.innerHTML = 'Não aplicável'
        this.input = 0
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .question {
    width: 60%;
    margin-bottom: 62px;
    &:last-child {
      margin: 0;
    }
    @media (max-width: 576px) {
      width: 90%;
      margin-bottom: 64px;
      &:first-child {
        margin-top: 124px;
      }
      &:last-child {
        margin-bottom: 124px;
      }
    }
    @media (min-width: 577px) and (max-width: 950px) {
      width: 650px;
    }
    .question-description {
      display: flex;
      align-items: center;
      justify-content: space-between;
      @media (max-width: 576px) {
        flex-direction: column;
      }
    }
    .question-number {
      font-size: 42px;
      padding: 0 36px;
    }
    .question-title {
      font-size: 18px;
      line-height: 22px;
      letter-spacing: 1px;
      text-indent: 1px;
      @media (max-width: 576px) {
        margin: 12px 0 24px;
        text-align: center;
      }
    }
    .question-answer {
      text-transform: uppercase;
      font-size: 18px;
      letter-spacing: 3px;
      text-indent: 3px;
      text-align: center;
      padding: 10px 20px;
      margin-left: 28px;
      line-height: 22px;
      width: 100px;
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex: 0 0 auto;
      transition: all .3s ease;
      &.green {
        background-image: linear-gradient(to right, rgba(97,202,115,0.1) 0%, rgba(97,202,115,0.3) 100%);
      }
      &.grey {
        background-image: linear-gradient(to right, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.3) 100%);
      }
      &.grey-dark {
        background-image: linear-gradient(to right, rgba(0,0,0,0.1) 0%, rgba(0,0,0,0.3) 100%);
      }
    }
    .question-form {
      display: flex;
      justify-content: space-between;
      margin-top: 28px;
        @media (max-width: 576px) {
          margin: 42px 36px 0;
        }
      .vue-slider-component {
        flex: 1;
      }
      .applicable {
        margin-left: 24px;
        text-transform: uppercase;
        letter-spacing: 2px;
        text-indent: 2px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        font-size: 14px;
        line-height: 14px;
        width: 141px;
        cursor: pointer;
        .checkbox {
          margin-left: 12px;
          position: relative;
          display: flex;
          &:before {
            content: '';
            display: block;
            background-color: rgba(black, .2);
            width: 30px;
            height: 10px;
            margin: 0 2px;
            transition: background-color .3s;
          }
          &:after {
            content: '';
            display: block;
            position: absolute;
            background-color: white;
            width: 10px;
            height: 10px;
            right: 80%;
            transform: rotate(45deg);
            transition: right .3s ease;
          }
        }
        &.active {
          .checkbox:before {
            background-color: rgba(white, .2);
          }
          .checkbox:after {
            right: 0;
          }
        }
      }
    }

    // Component v-slider
    /deep/ .vue-slider {
      .vue-slider-dot {
        border-radius: 0;
        transform: rotate(45deg);
        background: none;
        box-shadow: none;
        &:before {
          content: "";
          display: block;
          background-color: white;
          width: 16px;
          height: 16px;
          transform: rotate(45deg);
          box-shadow: 0px 0 25.23px 3.77px rgba(0, 0, 0, 0.1), 0px 0px 17px 0px rgba(0, 0, 0, 0.1);
        }
      }
      .vue-slider-tooltip {
        border-radius: 2px;
        box-shadow: 0px 21px 25.23px 3.77px rgba(0, 0, 0, 0.1), 0px 0px 17px 0px rgba(0, 0, 0, 0.1);
        background-color: rgba(white,.1);
        border-color: #656D72;
        letter-spacing: 2px;
        text-indent: 2px;
        font-size: 18px;
        &:after {
          content: '%'
        }
      }
      .vue-slider-piecewise {
          background-color: #474f54;
      }
      .vue-slider-process {
        background-color: #A4A8AA
      }
    }
  }

  @-moz-document url-prefix() {
    .question:last-child {
      padding-bottom: 150px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Question.vue